<template>
  <div>
    <v-card-actions class="hidden-sm-and-down">
      <v-spacer></v-spacer>

      <v-btn
        color="indigo darken-1"
        style="color: white"
        class="mr-2"
        large
        @click="buttonType('Entrance')"
      >
        <v-avatar left> <v-icon>search</v-icon> </v-avatar>查詢
      </v-btn>
      <!--
      <v-btn
        color="blue-grey darken-1"
        style="color: white"
        class="mr-2"
        large
        @click="buttonType('Resume')"
        v-show="!readOnlyFlag"
      >
        <v-avatar left>
          <v-icon>mdi-clipboard-file</v-icon> </v-avatar
        >Resume
      </v-btn>
      <v-btn
        color="brown darken-1"
        style="color: white"
        class="mr-2"
        large
        @click="buttonType('Temp')"
        v-show="!readOnlyFlag"
        :disabled="!valid"
      >
        <v-avatar left>
          <v-icon>mdi-content-save</v-icon> </v-avatar
        >Temp
      </v-btn>-->
      <v-btn
        color="teal"
        style="color: white"
        class="ma-2"
        large
        @click="buttonType('Submit')"
      >
        <v-avatar left> <v-icon>mdi-check</v-icon> </v-avatar>送出
      </v-btn>
    </v-card-actions>
    <v-card-actions class="hidden-sm-and-up">
      <v-spacer></v-spacer>
      <!-- <v-btn
        color="brown darken-1"
        style="color: white"
        class="ma-2"
        large
        @click="buttonType('Temp')"
        v-show="!readOnlyFlag"
        v-if="valid"
      >
        <v-avatar left> <v-icon>mdi-content-save</v-icon> </v-avatar>Temp
      </v-btn> -->
      <v-btn
        color="indigo darken-1"
        style="color: white"
        class="ma-2"
        large
        @click="buttonType('Entrance')"
      >
        <v-avatar left> <v-icon>search</v-icon> </v-avatar>查詢
      </v-btn>
      <v-btn
        color="teal"
        style="color: white"
        class="ma-2"
        large
        @click="buttonType('Submit')"
      >
        <v-avatar left> <v-icon>mdi-check</v-icon> </v-avatar>送出
      </v-btn>
    </v-card-actions>
    <v-card-actions class="hidden-sm-and-up">
      <v-spacer></v-spacer>

      <!-- <v-btn
        color="blue-grey darken-1"
        style="color: white"
        class="ma-2"
        large
        @click="buttonType('Resume')"
        v-show="!readOnlyFlag"
      >
        <v-avatar left> <v-icon>mdi-clipboard-file</v-icon> </v-avatar>Resume
      </v-btn> -->
    </v-card-actions>
  </div>
</template>
<script>
// document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
export default {
  name: "detail-view",
  props: {
    readOnlyFlag: {},
    valid: {},
  },
  data() {
    return {};
  },
  methods: {
    buttonType(type) {
      this.$emit("update-item", type);
    },
  },
  beforeCreate: function () {},
  created: function () {},
  mounted: function () {},
  beforeDestroy: function () {
    // document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
    // console.log("beforeDestroy");
  },
};
</script>